// TODO: kinda sus code, check if it useful
export function debounce<Params extends unknown[], Result>(
  func: (...args: Params) => Result,
  timeout: number,
): (...args: Params) => void {
  let timer: NodeJS.Timeout
  return (...args: Params) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func(...args)
    }, timeout)
  }
}
